// libs
import React from 'react'
import { MUIDataTableColumnOptions } from 'mui-datatables'

// shared
import StatusIndicator from 'presentation/hospital/components/DoctorRegister/StatusIndicator'
import {
  DoctorRegister,
  DoctorRegisterStatus,
  DoctorRegisterStep,
  DoctorRegisterStepStatus
} from 'domain/entities/doctor-register'

import { pendenciesStepInitials } from './data'

import * as S from './styles'
import moment from 'moment-timezone'

function RenderHeader() {
  return (
    <th
      style={{
        borderBottom: '1px solid rgba(224, 224, 224, 1)'
      }}
    />
  )
}
function RenderIsEmergencial(value: boolean) {
  if (value) return <S.Emergency>Emergencial</S.Emergency>

  return null
}
function RenderStatus(status: DoctorRegisterStatus) {
  return <StatusIndicator status={status} />
}
function RenderBody(value: DoctorRegisterStep[]) {
  const pendentSteps = value.filter(
    (step) => step.status === DoctorRegisterStepStatus.PENDENT
  )
  return (
    <S.Pendency>
      {pendentSteps.length > 0
        ? pendentSteps.map((step) => {
            const abbr = pendenciesStepInitials.find(
              (abbr) => abbr.step === step.name
            )
            return (
              <div key={step.name}>
                <abbr>{abbr?.inital}</abbr>
              </div>
            )
          })
        : '-'}
    </S.Pendency>
  )
}
function RenderSector(value: string[]) {
  return (
    <S.Sector>
      {value.length > 0
        ? value.map((step) => {
            const sectorAbbr = step.match(/\((.*)\)/)?.pop() // NOSONAR
            return (
              <div key={step}>
                <abbr>{sectorAbbr}</abbr>
              </div>
            )
          })
        : '-'}
    </S.Sector>
  )
}

interface TableColumns {
  label: string
  name: string
  options: MUIDataTableColumnOptions
}
export const getTableColumns = (isDirector: boolean): TableColumns[] => {
  return [
    {
      name: 'menu',
      label: ' ',
      options: { filter: false, sort: false, display: !isDirector }
    },
    {
      name: 'doctor_id',
      label: '',
      options: { filter: false, sort: false, display: 'false' }
    },
    {
      name: 'isEmergency',
      label: '',
      options: {
        filter: false,
        sort: false,
        customHeadRender: RenderHeader,
        customBodyRender: RenderIsEmergencial
      }
    },
    {
      name: 'status',
      label: 'status',
      options: {
        filter: false,
        sort: false,
        customHeadRender: RenderHeader,
        customBodyRender: RenderStatus
      }
    },
    {
      name: 'name',
      label: 'Nome do profissional',
      options: { filter: false, sort: false }
    },

    {
      name: 'pendencies',
      label: 'Tipo de pendência',
      options: {
        filter: false,
        sort: false,
        display: !isDirector,
        customBodyRender: RenderBody
      }
    },
    {
      name: 'crm',
      label: 'N.º do conselho',
      options: { filter: false, sort: false }
    },
    {
      name: 'registerQuantity',
      label: 'Qtd. de Registros',
      options: { filter: false, sort: false, display: !isDirector }
    },
    {
      name: 'crmUf',
      label: 'UF',
      options: { filter: false, sort: false, display: isDirector }
    },
    {
      name: 'immunization',
      label: 'Imunização',
      options: { filter: false, sort: false, display: !isDirector }
    },
    {
      name: 'specialty',
      label: 'Especialidade',
      options: { filter: false, sort: false }
    },
    {
      name: 'sectors',
      label: 'Setor de Atuação',
      options: {
        filter: false,
        sort: false,
        customBodyRender: RenderSector
      }
    },
    {
      name: 'recommendationDate',
      label: 'Data de indicação',
      options: { filter: false, sort: false }
    },
    {
      name: 'sentToDirectorAt',
      label: 'Recebido em:',
      options: { filter: false, sort: false, display: isDirector }
    }
  ]
}

export function formatRecommendationToTable(
  recommendation: DoctorRegister,
  menuOnClick?: (event: any, val: any) => void
) {
  return {
    menu:
      recommendation.status ===
      DoctorRegisterStatus.APPROVED_BY_DIRECTOR_WITH_PENDENCIES ? (
        <S.DotsIcon
          width={30}
          height={30}
          onClick={(e) => {
            e.stopPropagation()
            if (menuOnClick) menuOnClick(e, recommendation)
          }}
        />
      ) : (
        ''
      ),
    crm: recommendation.doctor?.crm,
    crmUf: recommendation.doctor?.crmUf,
    name: recommendation.doctor?.name,
    registerQuantity: recommendation.doctor?.councilRegister?.length,
    sectors: recommendation.doctor?.translatedSectors,
    immunization:
      recommendation.doctor?.immunization?.filter(
        (immunization) => immunization.immunized
      ).length +
      '/' +
      recommendation.doctor?.immunization?.length,
    specialty: recommendation.doctor?.specialties?.find(({ isMain }) => isMain)
      ?.name,
    pendencies: recommendation.steps || [],
    status: recommendation.status,
    doctor_id: recommendation.doctor_id,
    isEmergency: recommendation.doctor?.getDoctorRecommendation?.emergency,
    recommendationDate:
      recommendation.doctor?.getDoctorRecommendation?.recommended_by_id === 72
        ? 'Sem indicação'
        : recommendation.doctor?.getDoctorRecommendation?.updatedAt
        ? moment(recommendation.doctor?.getDoctorRecommendation?.updatedAt)
            .utc()
            .format('DD/MM/YYYY')
        : moment(recommendation.doctor?.getDoctorRecommendation?.createdAt)
            .utc()
            .format('DD/MM/YYYY'),
    sentToDirectorAt: recommendation?.sentToDirectorAt?.toLocaleDateString()
  }
}
